<script lang="ts">
  import type { OfficeReadDto } from '@cnpja/sdk';
  import { DividerHorizontal } from '$lib/components/divider';
  import { FormCheckbox, FormInput, FormSelect } from '$lib/components/form';
  import { AppFeatures } from '$lib/features/app';

  /** Default: `{}` */
  export let dto: Omit<OfficeReadDto, 'taxId'> = {};

  let initialized: boolean;
  let maxAgeBase: string;
  let maxAgeMultiplier = '1';
  let simples: boolean;
  let simplesHistory: boolean;
  let registrations: boolean;
  let suframa: boolean;
  let geocoding: boolean;

  /**
   * Build the DTO to read office data at API,
   * remove empty params to reduce bloat
   */
  $: {
    if (dto && !initialized) {
      initialized = true;

      if (dto.maxAge) maxAgeBase = String(dto.maxAge);
      if (dto.simples) simples = true;
      if (dto.simplesHistory) simplesHistory = true;
      if (dto.registrations) registrations = true;
      if (dto.suframa) suframa = true;
      if (dto.geocoding) geocoding = true;
    }

    if (maxAgeBase === '0') {
      maxAgeBase = '1';
    }

    if (simplesHistory) {
      simples = true;
    }

    dto = {
      maxAge: maxAgeBase ? Number(maxAgeBase) * Number(maxAgeMultiplier) : undefined,
      simples,
      simplesHistory,
      registrations: registrations ? ['BR'] : undefined,
      suframa,
      geocoding,
    };

    for (const key in dto) {
      if (!dto[key]) {
        delete dto[key];
      }
    }
  }
</script>

<div class="label mb-3">
  <p>Defasagem Máxima</p>
  <p class="text-surface-600-300-token text-sm">Atualizar online se nossos dados forem mais antigos que:</p>
</div>

<div class="flex items-center gap-2">
  <FormInput placeholder="45" width="w-16" bind:value={maxAgeBase} />

  <FormSelect width="w-32" bind:value={maxAgeMultiplier}>
    <option value="1">dias</option>
    <option value="7">semanas</option>
    <option value="30">meses</option>
  </FormSelect>
</div>

<p class="text-surface-600-300-token mt-6 text-sm">
  Os créditos serão debitados apenas para consultas online, respeitando o intervalo configurado acima. Dados já
  armazenados na plataforma não consomem créditos.
</p>

<DividerHorizontal margin="my-6" />

<div class="flex flex-col gap-6">
  <FormCheckbox
    label={AppFeatures.find((f) => f.name === 'RFB').title}
    description={AppFeatures.find((f) => f.name === 'RFB').description}
    credits={AppFeatures.find((f) => f.name === 'RFB').cost}
    checked={true}
    disabled={true}
  />

  <FormCheckbox
    label={AppFeatures.find((f) => f.name === 'SIMPLES').title}
    description={AppFeatures.find((f) => f.name === 'SIMPLES').description}
    credits={AppFeatures.find((f) => f.name === 'SIMPLES').cost}
    bind:checked={simples}
  />

  <FormCheckbox
    label={AppFeatures.find((f) => f.name === 'SIMPLES_HISTORY').title}
    description={AppFeatures.find((f) => f.name === 'SIMPLES_HISTORY').description}
    credits={AppFeatures.find((f) => f.name === 'SIMPLES_HISTORY').cost}
    bind:checked={simplesHistory}
  />

  <FormCheckbox
    label={AppFeatures.find((f) => f.name === 'CCC').title}
    description={AppFeatures.find((f) => f.name === 'CCC').description}
    credits={AppFeatures.find((f) => f.name === 'CCC').cost}
    bind:checked={registrations}
  />

  <FormCheckbox
    label={AppFeatures.find((f) => f.name === 'SUFRAMA').title}
    description={AppFeatures.find((f) => f.name === 'SUFRAMA').description}
    credits={AppFeatures.find((f) => f.name === 'SUFRAMA').cost}
    bind:checked={suframa}
  />

  <FormCheckbox
    label={AppFeatures.find((f) => f.name === 'MAP_GEOCODING').title}
    description={AppFeatures.find((f) => f.name === 'MAP_GEOCODING').description}
    credits={AppFeatures.find((f) => f.name === 'MAP_GEOCODING').cost}
    bind:checked={geocoding}
  />
</div>
